import { ReactNode } from "react";
import { Box, SxProps, Theme, useTheme } from "@mui/material";

const DrawerContentContainer = ({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: SxProps<Theme>;
}) => {
  const theme = useTheme();

  const wizardWrapperStyles = {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    [theme.breakpoints.up("lg")]: {
      width: "54vw",
    },
    [theme.breakpoints.down("lg")]: {
      width: "72vw",
    },
    [theme.breakpoints.down("md")]: {
      width: "72vw",
    },
  };
  const combinedSx: SxProps<Theme> = sx
    ? [
        wizardWrapperStyles,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]
    : [wizardWrapperStyles];

  return (
    <Box className="shionecsdrawer" sx={combinedSx}>
      {children}
    </Box>
  );
};

export default DrawerContentContainer;
